import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteIntegrationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteIntegrationModalContainer" */
      './DeleteIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
